import React, { useState, useEffect } from 'react';

export default function FontSizeControl() {
  // Three-step zoom via CSS variable --app-font-size on <html>.
  // Default 100% = 16px, A+ steps +1px up to 22px, A- steps -1px down to 13px.
  const MIN = 13, MAX = 22, BASE = 16;
  const [size, setSize] = useState(() => {
    const saved = parseInt(localStorage.getItem('erp_font_size') || String(BASE), 10);
    return Number.isFinite(saved) && saved >= MIN && saved <= MAX ? saved : BASE;
  });
  useEffect(() => {
    document.documentElement.style.setProperty('--app-font-size', `${size}px`);
    try { localStorage.setItem('erp_font_size', String(size)); } catch (e) { console.warn('[FontSize] Could not persist font size:', e.message); }
  }, [size]);
  const step = (delta) => setSize(s => Math.max(MIN, Math.min(MAX, s + delta)));
  const reset = () => setSize(BASE);
  const pct = Math.round((size / BASE) * 100);
  const btnStyle = {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    minWidth: 26, height: 26, padding: '0 6px', borderRadius: 6,
    border: '1px solid var(--border, #e2e8f0)',
    background: 'var(--surface-3, #f1f5f9)',
    color: 'var(--text-primary, #0f172a)',
    cursor: 'pointer', fontWeight: 700, lineHeight: 1,
    transition: 'background 150ms'
  };
  return (
    <div
      title={`Font size: ${size}px (${pct}%) \u2022 click A\u2212 / A / A+ to adjust`}
      data-testid="font-size-control"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
    >
      <button
        type="button"
        onClick={() => step(-1)}
        disabled={size <= MIN}
        data-testid="font-size-decrease"
        style={{ ...btnStyle, fontSize: 10, opacity: size <= MIN ? 0.4 : 1 }}
      >A\u2212</button>
      <button
        type="button"
        onClick={reset}
        title={`Reset to ${BASE}px (100%)`}
        data-testid="font-size-reset"
        style={{ ...btnStyle, fontSize: 11, fontWeight: size === BASE ? 700 : 600, color: size === BASE ? 'var(--brand-blue, #3b82f6)' : 'var(--text-primary)' }}
      >{pct}%</button>
      <button
        type="button"
        onClick={() => step(1)}
        disabled={size >= MAX}
        data-testid="font-size-increase"
        style={{ ...btnStyle, fontSize: 13, opacity: size >= MAX ? 0.4 : 1 }}
      >A+</button>
    </div>
  );
}
